/* eslint-disable no-undef */
import { io } from 'socket.io-client';
import Cookies from 'js-cookie';

// The live feed server for this build. UAT and prod share one host today;
// set REACT_APP_LIVEFEED_SOCKET_URL for a build that should use another.
const SOCKET_URL = (
  process.env.REACT_APP_LIVEFEED_SOCKET_URL || 'https://livefeed.housingram.com'
).replace(/\/$/, '');

const socket = io(SOCKET_URL, {
  // Only connect on load when someone is logged in; the login forms call
  // socket.connect() after sign-in, and logout disconnects.
  autoConnect: !!Cookies.get('token'),
  // socket.io's own backoff (1s, doubling to 10s) instead of retrying at once.
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10000,
  // Read on every (re)connect so a refreshed token or a new login is picked up.
  auth: (cb) => cb({ token: Cookies.get('token') }),
  transports: ['websocket']
});

// Log on connection error
socket.on('connect_error', (error) => {
  console.error('Connection error:', error.message);
});

export default socket;
